import { render } from "./Login.vue?vue&type=template&id=0c4c656e&scoped=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=0c4c656e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0c4c656e"

export default script